import { render, staticRenderFns } from "./incidentPage.vue?vue&type=template&id=1ac60f5d"
import script from "./incidentPage.vue?vue&type=script&lang=js"
export * from "./incidentPage.vue?vue&type=script&lang=js"
import style0 from "./incidentPage.vue?vue&type=style&index=0&id=1ac60f5d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports